import { css } from "styled-components";
const navTabsStyles = css(
  ({ theme }) => css`
    .nav-tabs {
      border-bottom-color: ${theme.colors.variant.default};

      > li {
        > a {
          transition: background-color 150ms ease-in-out;
          color: ${theme.colors.text.primary};
          border-color: ${theme.colors.variant.lighter.default} ${theme.colors.variant.lighter.default}
            ${theme.colors.variant.default};

          &:hover {
            background-color: ${theme.colors.variant.lightest.default};
            color: ${theme.colors.text.primary};
          }
        }

        &.active > a {
          &,
          &:hover,
          &:focus {
            color: ${theme.colors.variant.darkest.default};
            background-color: ${theme.colors.global.contentBackground};
            border-color: ${theme.colors.variant.default};
            border-bottom-color: transparent;
          }
        }

        &.disabled > a {
          &,
          &:hover,
          &:focus {
            color: ${theme.colors.gray[60]};
            background-color: ${theme.colors.gray[100]};
            border-color: ${theme.colors.gray[100]} ${theme.colors.gray[100]} ${theme.colors.variant.default};
            cursor: not-allowed;
          }
        }
      }
    }

    &.nav-justified {
      > .active > a {
        &,
        &:hover,
        &:focus {
          border-color: ${theme.colors.variant.default};
        }
      }

      @media (min-width: ${theme.breakpoints.min.sm}) {
        > li > a {
          border-bottom-color: ${theme.colors.variant.default};
        }

        > .active > a,
        > .active > a:hover,
        > .active > a:focus {
          border-bottom-color: ${theme.colors.gray[100]};
        }
      }
    }
  `
);
export default navTabsStyles;
